import { getFont, colors } from 'app/theme'
import css from 'styled-jsx/css'

export default css`
.content {
  display: flex;
  flex-direction: column;
  padding: 1.5rem;
  align-items: center;
  max-width: 500px;
  margin: 0 auto;
}

.password-type-badge {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  border-radius: 20px;
  ${getFont('semiBold', 'small')};
  letter-spacing: 0.5px;
  margin-bottom: 1rem;
}

.password-type-badge.plataforma {
  background-color: ${colors.primaryLight || '#e3f2fd'};
  color: ${colors.primary};
}

.password-type-badge.mailbox {
  background-color: ${colors.secondaryLight || '#fff3e0'};
  color: ${colors.secondary || '#ff9800'};
}

.password-type-badge > :global(i) {
  font-size: 1rem;
}

h3 {
  ${getFont('semiBold', 'h4')};
  display: flex;
  align-items: center;
  margin-bottom: 0.5rem;
  text-align: center;
}

h3 > :global(i) {
  color: ${colors.primary};
  margin-right: 0.5rem;
}

.subtitle {
  ${getFont('regular', 'p')};
  color: ${colors.gray};
  text-align: center;
  line-height: 1.5;
}

.subtitle.platform-message {
  margin-bottom: 1.5rem;
}

.subtitle :global(strong) {
    color: ${colors.text};
}

.mailbox-warning {
  display: block;
  margin: 0rem;
  padding: 0.5rem;
  background-color: ${colors.alpha(colors.warningLow, 0.2)};
  color: ${colors.secondary};
  border: 1px solid ${colors.alpha(colors.warningLow, 0.2)};
  border-radius: 8px;
  font-size: 0.875rem;
  line-height: 1.4;
}

.form-container {
  width: 100%;
}

.form-container :global(.password-profile),
.form-container :global(.password-mailbox) {
  width: 100%;
}

.form-container :global(form) {
  width: 100%;
}

.form-container :global(.form-input-margin) {
  margin-bottom: 1rem;
}

.form-container :global(button[type="submit"]) {
  margin-top: 0.5rem;
}

.error-message {
  color: ${colors.error};
  ${getFont('regular', 'small')};
  text-align: center;
  margin-top: 0.5rem;
}

.success-message {
  color: ${colors.success};
  ${getFont('regular', 'small')};
  text-align: center;
  margin-top: 0.5rem;
}

@media (max-width: 768px) {
  .title {
    font-size: 1.25rem;
  }
}
`
